<template>
    <div class="rl_air_control">
        <div class="air_cnt">
            <el-table
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                height="100%"
                style="width: 100%"
                border
                class="leader-style-table"
                @selection-change="handleSelectionChange">
                <el-table-column
                type="selection"
                width="55">
                </el-table-column>
                <el-table-column
                label="日期"
                width="120">
                <template slot-scope="scope">{{ scope.row.date }}</template>
                </el-table-column>
                <el-table-column
                prop="name"
                label="姓名"
                width="120">
                </el-table-column>
                <el-table-column
                prop="address"
                label="地址"
                show-overflow-tooltip>
                </el-table-column>
            </el-table>
        </div>
        <div class="air_cnt">
            <div class="air_title">控制面板</div>
            <div class="air_buttons">
                <el-form
                    label-width="150px"
                    :model="addForm"
                    :rules="addRules"
                    ref="addForm"
                    class="leader-style-form leader-radio"
                >
                    <el-form-item
                        label="开/关"
                        style="text-align: left"
                        prop="onoff"
                    >
                        <el-radio-group v-model="addForm.onoff" @change="doOnOffChange">
                            <el-radio label="1">开启</el-radio>
                            <el-radio label="0">关闭</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item
                        label="模式"
                        style="text-align: left"
                        prop="mode"
                    >
                        <el-radio-group v-model="addForm.mode" :disabled="isDisabled">
                            <el-radio label="0">制冷</el-radio>
                            <el-radio label="1">制热</el-radio>
                            <el-radio label="2">除湿</el-radio>
                            <el-radio label="3">送风</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item
                        label="风速"
                        style="text-align: left"
                        prop="speed"
                    >
                        <el-radio-group v-model="addForm.speed" :disabled="isDisabled">
                            <el-radio label="2">低风</el-radio>
                            <el-radio label="3">中风</el-radio>
                            <el-radio label="4">高风</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item
                        label="温度"
                        style="text-align: left"
                        prop="temp"
                    >
                        <el-input-number v-model="addForm.temp" controls-position="right" @change="handleChange" :min="0" :max="35" :disabled="isDisabled"></el-input-number>
                        <span style="color: #fff;width: 3rem;height: 1rem;font-size: 0.8rem;margin-left: 0.5rem;">°C</span>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="air_cnt_footer">
                <el-button class="leader-common-button"  @click="doSubmit">提 交</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import * as api from "@/http/api.js";
import moment from "moment";
export default {
    data() {
        return {
            isDisabled: false,
            addForm: {
                onoff: "1",
                mode: "0",
                speed: "0",
                temp: 26,
            },
            addRules: {
                onoff: [
                    {
                        required: true,
                        message: "请选择开/关",
                        trigger: "change"
                    }
                ],
                mode: [
                    {
                        required: true,
                        message: "请选择模式",
                        trigger: "change"
                    }
                ],
                speed: [
                    {
                        required: true,
                        message: "请选择风速",
                        trigger: "change"
                    }
                ],
                temp: [
                    {
                        required: true,
                        message: "请填写温度",
                        trigger: "blur"
                    }
                ],
            },
            tableData: [{
                date: '2016-05-03',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1518 弄'
            }, {
                date: '2016-05-02',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1518 弄'
            }, {
                date: '2016-05-04',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1518 弄'
            }, {
                date: '2016-05-01',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1518 弄'
            }, {
                date: '2016-05-08',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1518 弄'
            }, {
                date: '2016-05-06',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1518 弄'
            }, {
                date: '2016-05-07',
                name: '王小虎',
                address: '上海市普陀区金沙江路 1518 弄'
            }],
            multipleSelection: []
        };
    },
    mounted() {

    },
    methods: {
        doSubmit() {
            if(!this.multipleSelection.length) {
                this.$message({
                    type: "info",
                    message: "请选择空调",
                });
                return;
            }
            this.$refs["addForm"].validate((valid) => {
                if (valid) {
                    const param = [{
                        ...this.addForm
                    }];
                    console.log(111, this.multipleSelection)
                    console.log(2222, this.addForm)
                    // api.saveDeviceLedger(param).then((res) => {
                    //     if (res) {
                    //         this.$message({
                    //             message: res.error_msg,
                    //             type: "success",
                    //         });
                    //         this.getDeviceLedgerList();
                    //         this.diaClose();
                    //     }
                    // });
                }
            });
        },
        doOnOffChange(val) {
            console.log(11111, val)
            if(val == 0) {
                this.isDisabled = true;
            } else {
                this.isDisabled = false;
            }
        },
        toggleSelection(rows) {
            if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
                this.$refs.multipleTable.clearSelection();
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        }
    },
    computed: {
        
    }
};
</script>
<style lang="scss">
.rl_air_control {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0 40px;
    display: inline-flex;
    justify-content: space-between;
    .el-radio {
        color: #fff;
    }
    .el-radio__label {
        font-size: 0.85rem;
    }
    .el-input-number__increase {
        line-height: px2Rem(20px) !important;
    }
    .el-input-number__decrease {
        line-height: px2Rem(20px) !important;
    }
    .el-input-number {
        line-height: px2Rem(40px);
    }
    .el-radio__inner {
        width: 1rem;
        height: 1rem;
    }
    .leader-style-form .el-form-item {
        margin-bottom: 1rem !important;
    }
    .el-form-item__label {
        text-align: center;
    }
    .el-checkbox__inner {
        z-index: 0;
    }
    .air_cnt {
        width: 49%;
        height: 100%;
        border: 1px solid #366a7f;
        position: relative;
        .air_title {
            height: 3rem;
            line-height: 3rem;
            width: 100%;
            color: #fff;
            text-align: center;
            font-size: 1rem;
        }
        .air_buttons {
            width: 100%;
            height: calc(100% - 6rem);
            overflow-y: auto;
          //  border: 1px solid red;
        }
        .air_cnt_footer {
            position: absolute;
            bottom: 0;
            height: 3rem;
            width: 100%;
            text-align: center;
        }
    }
}
</style>
